import { camelize } from 'humps'
import { createSelector } from 'reselect'
import isEmpty from 'lodash/isEmpty'

import { resultDomain } from 'environments/TasteProfileOnboarding/selectors'
import { TASTE_PROFILE_WINE_LIST_URL } from 'constants/global'
import { tasteElementsOrder } from 'constants/ordering'
import { WINE_COLORS } from 'constants/wines'

const questionDomain = (state) => state.tasteProfileOnboarding.questions

const selectResult = createSelector(
  resultDomain,
  (result) => {
    if (isEmpty(result) || result.tasteProfiles === undefined) return {}

    // Append some useful stuff to the fetched data, so we have a nice package for the component
    return result.tasteProfiles.reduce((obj, profile) => {
      const color = profile.color
      const colorLabel = WINE_COLORS[color]
      const tasteElements = new Map()
      tasteElementsOrder
        .forEach(
          (tasteElement) => tasteElements.set(tasteElement, result.tasteElements[tasteElement]))

      const tasteType = result.tasteTypes
        .find((value) => value.color === color)
        .name

      obj[colorLabel] = Object.assign({}, profile, {
        tasteElements,
        tasteType,
        className: camelize(profile.name),
        winesUrl: TASTE_PROFILE_WINE_LIST_URL
      })

      return obj
    }, {})
  }
)

const selectAnswers = createSelector(
  questionDomain,
  (questions) => questions.map((question) => ({
    question: question.id,
    answer: question.answered
  }))
)

export {
  selectResult,
  selectAnswers
}
